import React, { useEffect, useMemo, useState } from 'react';
import ActivationComp from '@components/activation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cn from 'classnames';
import {
  activation, storeInfo, setStoreInfoFromRN, setdeviceInfoFromRN, appDetails,
  setDeviceTypeId, clearCardReader, login, setInActivityStatus,
  setScreenSaverStatus, setRelaunchTimestamp
} from '@reducers/oauth';
import {
  authenticate,
  subscribeToStoreChecks,
  subscribeToStoreNotifications,
  getStoreNotifications,
  getStoreChecks,
  connect as socketConnector
} from '../../sockets/communicator';
import {
  getAllChecks
} from '@reducers/storeChecks';
import {
  logCapiClientHealthInfo
} from '@reducers/utils';
import { setNotification, setErrorPopUp } from '@reducers/notification';
import { getObjectValue, getHeaders } from '@utility/helperFunction';
import Loader from '@components/common/Loader';
import { getStoreThemeUrl } from '@reducers/theme';
import EventEmitter from '@utility/eventSubscribers';
import { APP_CONFIG } from '@constants';
import { urlSearchParams } from '@utility/utills';
import Modal from '@components/common/Modal';
import { LABEL } from '../../veriables';
import { flowType } from '@utility/userInfo';
import { getMenu } from '@reducers/orders';
import { subscribe } from '../../CApiWebSocket/Subscriber';
import oneDineLogo from '@assets/images/oneDineActivationLogo.png';
import { getVenueStores, setVenueMode } from '../../reducers/fireboard/venue';
import { safeJsonParse } from '../../utility/helperFunction';
import { getVenueNotification } from '../../reducers/fireboard/venue'
import { setErrorOrderFlag } from '../../reducers/fireboard/errorOrder';
import { isObjectBlank } from '../../utility/fireboardUtil';

const ActivationCont = (props) => {

  // Props Destructuring

  const {
    clearCardReader,
    setErrorPopUp,
    auth,
    getMenu,
    getStoreThemeUrl,
    setStoreInfoFromRN,
    getAllChecks,
    setNotification,
    storeInfo,
    setdeviceInfoFromRN,
    setDeviceTypeId,
    setScreenSaverStatus,
    activation,
    deviceInfo,
    appDetails,
    serverAppTheme,
    errorOrderFlag,
    setVenueMode,
  } = props;

  // State Management

  const [uuid, setUuid] = useState();
  const [showError, setShowError] = useState('');
  const [isStoreInfoFail, setIsStoreInfoFail] = useState(false);

  // React Hooks

  useEffect(() => {
    if (window.ReactNativeWebView == undefined && window.location.href.indexOf("callcenter") > -1 && window.location.href.indexOf("landing") > -1) {
      window.localStorage.clear()
      window.sessionStorage.clear()
    }
    if (window.ReactNativeWebView) {
      EventEmitter.version(APP_CONFIG.VERSION);
      EventEmitter.enableSideBar(true);
    }
    clearCardReader();
    window.sessionStorage.setItem('appVersion', APP_CONFIG.VERSION);
    if (urlSearchParams('reactivate') !== 'true') {
      intialise();
    }
    return () => {
      window.sessionStorage.removeItem('appVersion');
    };
  }, []);

  const modalPopup = useMemo(() => {
    const errorMsg = {
      backgroundColor: serverAppTheme?.popUp_bg,
      color: serverAppTheme?.primary_text,
      zIndex: '100',
      cursor: 'pointer',
      backgroundClip: 'padding-box',
      height: '100%',
      borderRadius: "16px",
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow
    }

    return { errorMsg };
  }, [serverAppTheme]);

  // Methods

  const failureAct = (error) => {
    setNotification({
      message: error.message,
      type: 'danger'
    });
    setIsStoreInfoFail(true);
    setShowError(error.message);
  };

  /**
   * Kick off menu loading in the background after Store Info resolves.
   * Fire-and-forget — does not block navigation or the UI.
   */
  const preloadMenuInBackground = (storeId, isCallCenter) => {
    getMenu(storeId, isCallCenter, true);
  };

  const signInWithoutAPI = (employeeId, deviceType) => {
    try {
      EventEmitter.activateIngenicoDevice(() => {
      });
      EventEmitter.sendMessage({ type: 'initializeIngenico', data: { ...auth } }, () => {
      },
        () => {
          console.log('failure');
        });
    } catch (e) {
      console.log(e);
    }
    window.sessionStorage.setItem('userInfo', JSON.stringify({ id: employeeId, employeeCode: null }));
    if (deviceType === 3) {
      props.navigate(`${APP_CONFIG.BASE_URL}/kiosk/landing`);
    }
    if (deviceType === 7) {
      props.navigate(`${APP_CONFIG.BASE_URL}/callcenter/guestinformation`, { replace: true });
    }
  };

  const skipKioskLogin = (deviceType, kioskEmployeeId) => {
    return (deviceType === 3 && kioskEmployeeId && kioskEmployeeId > 0) ? signInWithoutAPI(kioskEmployeeId, deviceType) : props.navigate(`${APP_CONFIG.BASE_URL}/checkIn`);
  };
  const skipCallCenterLogin = (deviceType, callCenterEmployeeId) => {
    return (deviceType === 7 && callCenterEmployeeId && callCenterEmployeeId > 0) ? signInWithoutAPI(callCenterEmployeeId, deviceType) : props.navigate(`${APP_CONFIG.BASE_URL}/checkIn`);
  };

  const themeUrl = (brandId, storeId, deviceType, kioskEmployeeId, callCenterEmployeeId, startMode, deviceGroup) => {
    const deviceTypeName = flowType();
    switch (deviceTypeName) {
      case 'paymentTerminal': getStoreThemeUrl(brandId, storeId, 'serverApp').then(() => {
        props.navigate(`${APP_CONFIG.BASE_URL}/checkIn`, { replace: true });
      });
        break;
      case 'serverApp': getStoreThemeUrl(brandId, storeId, 'serverApp').then(() => {
        if (startMode === 2) {
          skipCallCenterLogin(deviceType, callCenterEmployeeId);
        } else {
          props.navigate(`${APP_CONFIG.BASE_URL}/checkIn`, { replace: true });
        }
      });
        break;
      case 'fireboard':
        getStoreThemeUrl(brandId, storeId, 'fireboard').then(() => {
          if (deviceGroup?.fireBoardView === 2) {
            return props.navigate(
              `${APP_CONFIG.BASE_URL}/fireboard/cubbyManager`,
              { replace: true }
            );
          } else if (deviceGroup?.fireBoardView === 3) {
            return props.navigate(
              `${APP_CONFIG.BASE_URL}/fireboard/orderStatusManger`,
              { replace: true }
            );
          } else {
            return props.navigate(`${APP_CONFIG.BASE_URL}/fireboard`, {
              replace: true,
            });
          }
        });
        break;
      default: getStoreThemeUrl(brandId, storeId, deviceTypeName).then(() => {
        skipKioskLogin(deviceType, kioskEmployeeId);
      });
        break;
    }
  };
  const checkForErrorOrder = check => {
    const { errorOrderFlag } = props;
    if (errorOrderFlag) return;
    const deviceGroup = safeJsonParse(window.sessionStorage.getItem('deviceInfo'), {})
      ?.deviceGroup;
    let showErrorOrder = false;

    if (!isObjectBlank(deviceGroup)) {
      showErrorOrder = deviceGroup?.fireBoardSettings?.displayErrorOrderWarning;
    }

    if (showErrorOrder) {
      const order = check?.orders?.[0];
      if (order?.orderStatusId === 9) {
        props.setErrorOrderFlag(true);
      }
    }
  };

  const continueWithOutApi = (headers, responseObj, deviceType, res) => {
    props.setRelaunchTimestamp(Date.now() + (res?.relaunchInterval || 0) * 60 * 1000);
    setStoreInfoFromRN(res).then(() => {
      const connectionOptions = {
        reconnectionDelay: 500,
        reconnectionAttempts: Infinity,
      };
      socketConnector({
        url: res.cApiHostname && res.cachingProvider === 1 ? res.cApiHostname : process.env.REACT_APP_API_SOCKET_HOST || 'https://yapi.dev.onedine.com/iapi/connect',
        connectCallback: () => {
          console.warn('websocket connection successful');
        },
        disconnectCallback: () => {
          console.warn('websocket connection unsuccessful');
        },
        connectionOptions,
        apiKey: responseObj.apiKey,
        deviceExternalId: responseObj.deviceExternalId,
        storeId: res.id,
        deviceTypeId: res.deviceTypeId,
        // logCapiClientHealthInfo: logCapiClientHealthInfoHandler,
        subscriber: (data) => { checkForErrorOrder(data?.checkHeader); subscribe(data); }
      });
      if (!res.cApiHostname) {
        authenticate({ headers: { 'api-key': res.syncApiKey }, id: getObjectValue(() => res.id, 0) });
        subscribeToStoreChecks(getObjectValue(() => res.id, 0));
        if (![3, 10].includes(deviceType)) {
          getStoreChecks(getObjectValue(() => res.id, 0));
        }
      } else {
        const startMode = responseObj?.deviceGroup?.startMode;
        if (startMode === 6) {
          setVenueMode(true);

          const deviceId = responseObj?.deviceId;
          props.getVenueStores(deviceId).then(response => {
            props.getAllChecks(response.id, null, true);
            props.getVenueNotification(response.id);
          });
        }

        else {
          getAllChecks(responseObj.storeId);
        }
      }
      switch (deviceType) {
        case 11: props.navigate(`${APP_CONFIG.BASE_URL}/checkIn?step=3`); break;
        case 8: props.navigate(`${APP_CONFIG.BASE_URL}/checkIn?step=4`); break;
        case 14: props.navigate(`${APP_CONFIG.BASE_URL}/checkIn?step=5`); break;
        default: {
          if (!res.cApiHostname) {
            subscribeToStoreNotifications(getObjectValue(() => res.id, 0));
            getStoreNotifications(getObjectValue(() => res.id, 0));
          }
          themeUrl(res.brandId, responseObj.storeId, deviceType, res.kioskEmployeeId, res.callCenterEmployeeId, responseObj?.deviceGroup?.startMode, responseObj?.deviceGroup);
          break;
        }
      }
      // Preload menu in the background immediately after Store Info resolves.
      preloadMenuInBackground(res.id, responseObj?.deviceGroup?.startMode === 2);
    }).catch(failureAct);
  };

  const storeinfo = (headers, responseObj, deviceType) => {
    storeInfo(headers, responseObj.deviceId).then((res) => {
      props.setRelaunchTimestamp(Date.now() + (res?.relaunchInterval || 0) * 60 * 1000);
      const connectionOptions = {
        reconnectionDelay: 500,
        reconnectionAttempts: Infinity,
      };
      socketConnector({
        url: res.cApiHostname && res.cachingProvider === 1 ? res.cApiHostname : process.env.REACT_APP_API_SOCKET_HOST || 'https://yapi.dev.onedine.com/iapi/connect',
        connectCallback: () => {
          console.warn('websocket connection successful');
        },
        disconnectCallback: () => {
          console.warn('websocket connection unsuccessful');
        },
        connectionOptions,
        apiKey: responseObj.apiKey,
        deviceExternalId: responseObj.deviceExternalId,
        storeId: res.id,
        deviceTypeId: res.deviceTypeId,
        // logCapiClientHealthInfo: logCapiClientHealthInfoHandler,
        subscriber: (data) => { checkForErrorOrder(data?.checkHeader); subscribe(data); }
      });
      if (!res.cApiHostname) {
        authenticate({ headers: { 'api-key': res.syncApiKey }, id: getObjectValue(() => res.id, 0) });
        subscribeToStoreChecks(getObjectValue(() => res.id, 0));
        if (![3, 10].includes(deviceType)) {
          getStoreChecks(getObjectValue(() => res.id, 0));
        }
      } else {
        const startMode = responseObj?.deviceGroup?.startMode;
        if (startMode === 6) {
          setVenueMode(true);
          const deviceId = responseObj?.deviceId;
          props.getVenueStores(deviceId).then(response => {
            props.getAllChecks(response.id, null, true);
            props.getVenueNotification(response.id);
          });
        } else {
          getAllChecks(responseObj.storeId);
        }
      }
      switch (deviceType) {
        case 11: props.navigate(`${APP_CONFIG.BASE_URL}/checkIn?step=3`); break;
        case 8: props.navigate(`${APP_CONFIG.BASE_URL}/checkIn?step=4`); break;
        case 14: props.navigate(`${APP_CONFIG.BASE_URL}/checkIn?step=5`); break;
        default: {
          if (!res.cApiHostname) {
            subscribeToStoreNotifications(getObjectValue(() => res.id, 0));
            getStoreNotifications(getObjectValue(() => res.id, 0));
          }
          themeUrl(res.brandId, responseObj.storeId, deviceType, res.kioskEmployeeId, res.callCenterEmployeeId, responseObj?.deviceGroup?.startMode, responseObj?.deviceGroup);
          break;
        }
      }
      // Preload menu in the background immediately after Store Info resolves.
      // This ensures the menu is ready before the user reaches the Order screen.
      preloadMenuInBackground(res.id, responseObj?.deviceGroup?.startMode === 2);
    }).catch((error) => {
      props.setRelaunchTimestamp(null);
      failureAct(error);
    });
  };

  const activate = (data, uu, version, deviceTypeId, deviceExternalId) => {
    const dataToSend = {
      latitude: '32',
      longitude: '32',
      geoLocation: '32,32',
      activationCode: data.activationCode || '',
      deviceExternalId,
      uuid: uu || uuid,
      isSimPay: false,
      nextGen: true,
      appVersion: version ?? null,
      webVersion: APP_CONFIG.VERSION ?? null
    };
    if (window.ReactNativeWebView) {
      setTimeout(() => {
        const data = safeJsonParse(window.localStorage.getItem('activation'), {});
        if (data != undefined && data != null && data != "undefined" && data != "null" && data?.deviceInfo != null && data?.storeInfo && data?.deviceApi) {
          try {
            activation(dataToSend)
          } catch (e) {
            console.error(e?.message)
          }
          window.localStorage.removeItem('activation');
          setdeviceInfoFromRN(data?.deviceApi.data)
          window.sessionStorage.setItem('lastRebootOn', data.lastRebootOn)
          window.localStorage.setItem('deviceExternalId', data?.deviceInfo?.deviceExternalId);
          let date = new Date();
          let time = date.getHours() + ":" + date.getMinutes()
          window.sessionStorage.setItem('deviceActivatedTime', time);
          const headers = {
            'x-api-authentication': `${data?.deviceInfo?.deviceExternalId}:${data?.deviceInfo?.password}`,
            'x-api-key': data?.deviceInfo?.apiKey
          };
          const type = Number(deviceTypeId) || data?.deviceInfo?.deviceTypeId;
          window.sessionStorage.setItem('headers', JSON.stringify(headers));
          if (window.ReactNativeWebView) {
            EventEmitter.postEnableResizeView(false);
          }
          setDeviceTypeId(type).then(() => {
            const storeInfoData = data?.storeInfo?.data?.data ?? data?.storeInfo?.data;
            continueWithOutApi(headers, data?.deviceApi?.data, type, storeInfoData);
          });
          setScreenSaverStatus(type === 6 || type === 7);

        } else {
          activation(dataToSend).then((res) => {
            window.localStorage.setItem('deviceExternalId', res.deviceExternalId);
            let date = new Date();
            let time = date.getHours() + ":" + date.getMinutes()
            window.sessionStorage.setItem('deviceActivatedTime', time);
            const headers = {
              'x-api-authentication': `${res.deviceExternalId}:${res.password}`,
              'x-api-key': res.apiKey
            };
            const type = Number(deviceTypeId) || res.deviceTypeId;
            window.sessionStorage.setItem('headers', JSON.stringify(headers));
            setDeviceTypeId(type).then(() => {
              storeinfo(headers, res, type);
            });
            if (window.ReactNativeWebView) {
              EventEmitter.postEnableResizeView(false);
            }
            setScreenSaverStatus(type === 6 || type === 7);
          }).catch((error) => {
            if (showError || error) {
              setErrorPopUp({
                res:error.message
              })
            }
          });
        }
      }, 2000);
    } else {
      activation(dataToSend).then((res) => {
        window.localStorage.setItem('deviceExternalId', res.deviceExternalId);
        let date = new Date();
        let time = date.getHours() + ":" + date.getMinutes()
        window.sessionStorage.setItem('deviceActivatedTime', time);
        const headers = {
          'x-api-authentication': `${res.deviceExternalId}:${res.password}`,
          'x-api-key': res.apiKey
        };
        const type = Number(deviceTypeId) || res.deviceTypeId;
        window.sessionStorage.setItem('headers', JSON.stringify(headers));
        setDeviceTypeId(type).then(() => {
          storeinfo(headers, res, type);
        });
        if (window.ReactNativeWebView) {
          EventEmitter.postEnableResizeView(false);
        }
        setScreenSaverStatus(type === 6 || type === 7);
      }).catch((error) => {
        if (showError || error) {
          setErrorPopUp({
            res:error.message
          })
        }
      });
    }
  };

  const intialise = async () => {
    const query = new URLSearchParams(props.location.search);
    const currentUrl = window.location.href;
    const paramUuid = query.get('uuid');
    const callId = query.get('call_id');
    const ANI = query.get('ANI');
    const DNIS = query.get('DNIS');
    const nativeAppVersion = query.get('appVersion');
    const nativeEnvironment = query.get('environment');
    const deviceTypeId = query.get('deviceTypeId');
    const empId = query.get('employeeId');
    const checkId = query.get('checkId');
    appDetails({ appVersion: nativeAppVersion, environment: nativeEnvironment });
    if (!paramUuid) {
      const deviceExternalId = localStorage.getItem('deviceExternalId');
      const urlData = currentUrl.split('/');
      if (urlData[urlData.length - 2] === 'activationCode') {
        const deviceId = urlData[urlData.length - 1];
        window.localStorage.setItem('deviceExternalId', deviceId);
        activate({}, '', nativeAppVersion, deviceTypeId, deviceId);
      } else if (callId && ANI && DNIS) {
        const deviceId = query.get('storeid');
        window.localStorage.setItem('deviceExternalId', deviceId);
        window.sessionStorage.setItem('callCenter', JSON.stringify({ ANI, DNIS, callId }));
        activate({}, '', nativeAppVersion, deviceTypeId, deviceId);
      } else if (deviceExternalId) {
        activate({}, '', nativeAppVersion, deviceTypeId, deviceExternalId);
      }
    } else {
      if (empId) {
        window.sessionStorage.setItem('launchFromExternalDevice', JSON.stringify({ empId: empId, checkId: checkId }));
      }
      setUuid(paramUuid);
      activate({}, paramUuid, nativeAppVersion, deviceTypeId);
    }
  };

  // HTML and CSS code

  return (
    <div>
      {props.loading && <div>
        <Loader message="Launching..."/>
        <div className='h1 mt-100 text-center' style={{ color: '#000' }}>
         {props.loading && ( <img src={oneDineLogo} width="318px" alt="onedine" />)}
        </div>
      </div>}
      {props.loading && <div><Loader message="Launching..."/></div>}
      {!localStorage.getItem('deviceExternalId') && (<ActivationComp activate={activate} />)}
      {isStoreInfoFail && (
        <Modal
          isOpen={isStoreInfoFail}
          isModalCenter
          style={{backgroundColor: '#2F2F2F', borderRadius: '16px', border: "1px solid #626262"}}
          noBackground
          customClass2={cn("w-100 h-100 p-3")}
        >
          <div
            className={cn('w-100 fs_18 row mx-0 p-3')}
            style={modalPopup.errorMsg}
          >
            <div className="text-center py-2 w-100">
              {showError}
            </div>
            <div
              className="col-12 align-items-center text-center p-2"
            >
              <button
                type="button"
                className={cn("w-40 od-btn-primary btn-ripple btn35 rounded")}
                style={{backgroundColor: "#0060FF", border: "none", color: "white"}}
                onClick={() => storeinfo(getHeaders(), deviceInfo)}
              >
                {LABEL().RETRY}
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};




// Redux Part

const mapDispatchToProps = (dispatch) => bindActionCreators({
  activation,
  setNotification,
  getStoreThemeUrl,
  storeInfo,
  setStoreInfoFromRN,
  setdeviceInfoFromRN,
  appDetails,
  setDeviceTypeId,
  clearCardReader,
  login,
  getMenu,
  setInActivityStatus,
  setScreenSaverStatus,
  getAllChecks,
  logCapiClientHealthInfo,
  setErrorPopUp,
  setVenueMode,
  getVenueStores,
  getVenueNotification,
  setErrorOrderFlag,
  setRelaunchTimestamp
}, dispatch);

const mapStateToProps = ({ oauth, theme, errorOrder }) => ({
  loading: oauth.loading,
  auth: oauth.authInfo,
  nativeAppVersion: oauth.nativeAppVersion,
  deviceInfo: oauth.deviceInformation,
  serverAppTheme: theme.serverAppTheme,
  errorOrderFlag: errorOrder.errorOrderFlag
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivationCont);
